<outlaw-dialog-wrapper dialogTitle="Recommended by">
  <outlaw-lazy-load-list
    [items]="members"
    [isLoading]="isLoading"
    class="members-list"
    [class.loading]="isLoading"
    [class.has-scroll]="hasMembersScroll"
    [canHideInfiniteScroll]="hasMembers"
    (getItemsEvent)="fetchItems()"
  >
    <ng-template let-item>
      <ol-follow-member [member]="item" (memberClickEvent)="openUserProfile($event)" [showFollowBtn]="!!meId" />
    </ng-template>
  </outlaw-lazy-load-list>
</outlaw-dialog-wrapper>
